import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'

import { BaseDialog } from 'components'
import { ReviewOpinionContent } from './components'

// Ação "Ver parecer" encaixada na faixa de status do controle (ActivityAlert), com a modal do parecer.
const ReviewOpinion = ({ latestReview }) => {
  const [isOpinionDialogOpen, setIsOpinionDialogOpen] = useState(false)

  return (
    <>
      <Button
        color="inherit"
        size="small"
        onClick={() => setIsOpinionDialogOpen(true)}
      >
        Ver parecer
      </Button>
      <BaseDialog
        open={isOpinionDialogOpen}
        setOpen={setIsOpinionDialogOpen}
        title="Parecer do revisor"
        closeButtonText="Fechar"
        dialogSize="md"
        fullWidth
        paperStyle={{ height: '85%' }}
      >
        <ReviewOpinionContent opinion={latestReview?.latestSentOpinion} />
      </BaseDialog>
    </>
  )
}

ReviewOpinion.propTypes = {
  latestReview: PropTypes.shape({
    latestSentOpinion: PropTypes.object,
  }).isRequired,
}

export default ReviewOpinion
